var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 1707 1707",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil0 {fill:currentColor}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1028 899c-6,0 -12,-2 -16,-6l-68 -68c-11,7 -24,11 -38,11l-102 0c-41,0 -75,-34 -75,-75l0 -232c0,-41 34,-75 75,-75l102 0c41,0 74,34 74,75l0 232c0,11 -2,21 -6,30l70 70c14,14 4,38 -16,38zm475 246c-12,0 -23,-10 -23,-23l0 -496c0,-30 46,-30 46,0l0 496c0,13 -10,23 -23,23zm-183 0c-13,0 -23,-10 -23,-23l0 -496c0,-30 45,-30 45,0l0 496c0,13 -10,23 -22,23zm-1214 107c-16,0 -27,-16 -21,-31l49 -124 -111 0c-13,0 -23,-10 -23,-23l0 -794c0,-13 10,-23 23,-23l1116 0c12,0 23,10 23,23l0 174 522 0c13,0 23,10 23,23l0 794c0,13 -10,23 -23,23l-111 0c7,17 51,124 51,133 0,17 -18,28 -33,21l-326 -154 -697 0c-13,0 -23,-10 -23,-23l0 -174 -103 0c-15,3 -320,155 -336,155zm-61 -201l122 0c16,0 27,16 21,31l-40 103 279 -132c10,-4 120,-2 141,-2l548 0 0 -749 -1071 0 0 749 0 0zm545 198l680 0c3,0 6,0 9,2l280 131 -40 -102c-6,-15 5,-31 21,-31l121 0 0 -749 -499 0 0 574c0,13 -11,23 -23,23l-549 0 0 152zm-456 -413c-13,0 -23,-11 -23,-23l0 -336c0,-13 10,-23 23,-23l168 0c30,0 30,46 0,46l-145 0 0 122 145 0c30,0 30,46 0,46l-145 0 0 145c0,12 -11,23 -23,23zm775 -46l-62 -62c-21,-21 11,-53 32,-32l56 55 0 -222c0,-16 -13,-29 -29,-29l-102 0 0 0c-16,0 -29,13 -29,29l0 232c0,16 13,29 29,29l105 0zm-245 46c-8,0 -16,-5 -20,-13l-52 -108 -180 0 -52 108c-13,27 -54,7 -41,-20l163 -336c8,-17 32,-17 41,0l162 336c7,15 -4,33 -21,33zm-230 -166l136 0 -68 -141 -68 141z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.97cde68391c95947042edbb51b2479bd.svg";
export { ForwardRef as ReactComponent };